import { render, staticRenderFns } from "./FileViewerGo.vue?vue&type=template&id=7e9995e1&scoped=true&"
import script from "./FileViewerGo.vue?vue&type=script&lang=ts&"
export * from "./FileViewerGo.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewerGo.vue?vue&type=style&index=0&id=7e9995e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9995e1",
  null
  
)

export default component.exports